import { z } from 'zod';

export const CommentInputCandidateParamsSchema = z.object({
  key: z.string(),
  objectId: z.string().uuid(),
  preset: z.boolean().optional(),
});

export const CommentInputCandidateUsersModel = z.object({
  key: z.string(),
  objectId: z.string().uuid(),
  userIds: z.string().uuid().array(),
});

export const CommentInputCandidateOrganizationsModel = z.object({
  key: z.string(),
  objectId: z.string().uuid(),
  organizationIds: z.string().uuid().array(),
});
